import $ from "jquery";

$(document).on('turbolinks:load', function () {

    $('#event').on('change', function () {
        $('#quantity').val('');
        $('#price').val('');
        $('#last_name').val('');
        $('#mother_last_name').val('');
        $('#first_name').val('');
        $('#email').val('');
        $('#phone_number').val('');
        $('#comment').val('');
        document.getElementById('leyenda').innerHTML = '';

        var x = document.getElementById("comment-section");
        if ($("#event").val() == '') {
            x.style.display = "none";
        } else {
            // x.style.display = "block";
        }

        $.ajax({
            type: 'GET',
            url: '/get_info_event/' + $("#event").val(),
            contentType: "application/json",
            dataType: 'json',
            success: function (result) {
                if (result) {
                    $('#quantity').attr( "max", result.Disponibles );
                    $('#price').val(result.Valor);
                    $('#original_price').val(result.Valor);
                    $('#faculty').val(result.Facultad);
                    $('#concept_id').val(result.Codigo);
                    $('#quantity').prop( "disabled", false );
                    $('#quantity').val(1);
                    document.getElementById('leyenda').innerHTML = result.Leyenda;
                }
            },
            error: function (error) {

            }
        });
    });

    $('#quantity').on('change', function () {
        var price = $('#original_price').val();
        var get_quantity = $('#quantity').val();
        var quantity = (parseFloat(get_quantity).toFixed(1))
        var new_total = quantity * price;

        $('#price').val(parseFloat(new_total).toFixed(1));
    });

    $('input[type="number"]').on('keypress', function(e){
        if (e.which < 48 || e.which > 57) {
            e.preventDefault();
            return false;
        }
    });

})